import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function HomePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 text-center bg-gradient-to-b from-yellow-100 via-pink-100 to-white">

      {/* 🌙 Floating Mascot */}
      <motion.div
        initial={{ y: -10 }}
        animate={{ y: [-10, -20, -10] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="text-6xl mb-2"
      >
        🌙
      </motion.div>

      {/* 🚀 Hero Card */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white/90 sm:mt-0 p-8 rounded-3xl shadow-2xl max-w-xl w-full"
      >
        <h1 className="text-4xl sm:text-5xl font-bold text-yellow-700 font-[Comic Sans MS,cursive] mb-6 drop-shadow-sm">
         Welcome to Arabic Leanring Hub
        </h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="text-lg sm:text-xl text-gray-700 mb-8 font-sans"
        >
          A fun & friendly world where kids learn Arabic, Surahs, Prayers, and Stories of the Prophets! 🌟
        </motion.p>

        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/game"
            className="bg-pink-400 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-md hover:bg-pink-300 transition-all"
          >
            🎮 Play Games
          </Link>
          <Link
            to="/lessons"
            className="bg-yellow-400 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-md hover:bg-yellow-300 transition-all"
          >
            🚀 Start Learning
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default HomePage;
